<template>
  <el-dialog :title="customerName" :visible.sync="visible" width="50%">
    <BusinessList :customerId="customerId" height="400"></BusinessList>
  </el-dialog>
</template>

<script>
import BusinessList from "@/views/crm/business/businessList";

export default {
  name: "BusinessListDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      customerName: "",
      customerId: null
    };
  },
  created() {
  },
  components: {
    BusinessList
  },
  watch: {
    visible (val) {
      if (!val) {
        this.customerId = null
      }
    }
  },
  methods: {
    open (customerId, customerName) {
      if (!customerId) {
        this.msgError("没有选中任何客户")
        return
      }
      this.customerId = customerId
      this.customerName = customerName
      this.visible = true
    }
  }
};
</script>
